import React, { Component } from 'react';
import { Container, Icon, Divider, Menu } from 'semantic-ui-react';
import smoothscroll from 'smoothscroll-polyfill';
import Link from 'gatsby-link';
import ContactUs from './contact-us';
import Snackbar from './snackbar';
import '../styles/navbar.scss';

const isIE = () => {
  const ua = navigator.userAgent;
  /* MSIE used to detect old browsers and Trident used to newer ones*/
  const is_ie = ua.includes("MSIE ")|| ua.includes("Trident/");

  return is_ie;
}

export default class Navbar extends Component {
  constructor() {
    super();

    this.state = {
      activeItem: 'home',
      mobileMenuShow: false,
      isMobile: false,
      contact: false,
      path(){ return '/' },
    };

    this.handleItemClick = this.handleItemClick.bind(this);
    this.handleWindowResize = this.handleWindowResize.bind(this);
    this.handleScrollEvent = this.handleScrollEvent.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.renderNavBar = this.renderNavBar.bind(this);
  }

  componentDidMount() {
    smoothscroll.polyfill();
    this.setState({ isMobile: window.innerWidth < 675, path(){return window.location.pathname} });
    window.addEventListener('scroll', this.handleScrollEvent);
    window.addEventListener('resize', this.handleWindowResize);

    if (isIE()) {
      console.warn('This is IE, some things might not work well')
      // force opacity to react reveal
     const reactReveals = Array.prototype.slice.call(document.querySelectorAll('.react-reveal'))
     reactReveals.forEach(ele => {
       ele.classList.add('force-reveal')
       ele.classList.remove('react-reveal');
     })
    }

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('scroll', this.handleScrollEvent);
  }

  renderNavBar(display) {
    if (this.state.path() === '/') {
      return (
        <Menu.Menu position="right" className="navbar__mobile-menu" style={{ display }}>
        <Menu.Item className="navbar__link" name="about" onClick={this.handleItemClick} > ABOUT </Menu.Item>
          <Menu.Item className="navbar__link" name="speakers" onClick={this.handleItemClick} > PLENARIES</Menu.Item>
          <Menu.Item className="navbar__link" > <Link to='presenters'>PRESENTERS</Link></Menu.Item>
              <Menu.Item className="navbar__link" name="schedule" onClick={this.handleItemClick} > SCHEDULE </Menu.Item>
              <Menu.Item className="navbar__link" name="travel" onClick={this.handleItemClick} > TRAVEL </Menu.Item>
              {/* <Menu.Item className="navbar__link" name="register" onClick={this.handleItemClick} > REGISTER</Menu.Item> */}
              <Menu.Item className="navbar__link" name="sponsors" onClick={this.handleItemClick} > SPONSORS</Menu.Item>
          <Menu.Item className="navbar__link" name="contact"> <a target="_blank" href="mailto:pmena2018sc@gmail.com"> CONTACT</a> </Menu.Item>
          </Menu.Menu>
      )
    } else {
      return (
        <Menu.Menu position="right" className="navbar__mobile-menu" style={{ display }}>
          <Menu.Item className="navbar__link" name="contact"> <Link to='/'>HOME</Link> </Menu.Item>
          <Menu.Item className="navbar__link" name="contact"> <a target="_blank" href="mailto:pmena2018sc@gmail.com"> CONTACT</a> </Menu.Item>
        </Menu.Menu>
      )

    }
  }
  handleScrollEvent() {
    const navbar = document.querySelector('.navbar__menu');
    const hero = document.querySelector('.hero');
    if (this.state.path() !== '/' || hero === null) return;
    if (hero.getBoundingClientRect().top > -60) {
      navbar.classList.remove('show-background');
    } else {
      navbar.classList.add('show-background');
    }
  }

  handleModalClose(e) {
    if (e.target.className === 'modal') {
      this.setState({ contact: false })
    }
  }
  closeModal() {
    // Always close modal
    this.setState({ contact: false });
  }

  handleItemClick(e, { name }) {

    this.setState({ activeItem: name, mobileMenuShow: false });
    this.handleScrollToElement(name);
  }

  handleScrollToElement(node) {
    const tesNode = document.getElementById(node);
    // window.scrollTo(0, tesNode.offsetTop - 60);
    window.scroll({ top: tesNode.offsetTop - 60, left: 0, behavior: 'smooth' });
  }

  mobileMenuToggle() {
    const newState = !this.state.mobileMenuShow;
    this.setState({ mobileMenuShow: newState });
    const navbar = document.querySelector('.navbar__menu');
    if (newState) {
      navbar.classList.add('show-background');
    } else {
      const hero = document.querySelector('.hero');
      if (typeof hero === 'undefined') return
      if (hero.getBoundingClientRect().top > -60) {
        navbar.classList.remove('show-background');
      }
    }
  }

  handleWindowResize() {
    this.setState({ isMobile: window.innerWidth < 675 });
  }


  render() {
    const { activeItem, isMobile } = this.state;
    let classes = 'navbar__menu';
    const onHomePage = this.state.path() === '/';
    if (!onHomePage){
      classes = 'navbar__menu show-background';
    }
    let display = 'flex';
    if (isMobile) {
      display = this.state.mobileMenuShow ? 'block' : 'none';
    }

    return (
      <div className="navbar" id="home">
        <Menu className={classes} stackable secondary pointing fixed="top">
          <Menu.Item className="navbar__logo" name="home" onClick={this.handleItemClick}>
          PME-NA<sup>40</sup> &nbsp; | <span className="navbar__logo-extra">2018 Annual Conference</span>
          </Menu.Item>
            {this.renderNavBar(display)}

          <div role="button" className="navbar__mobile-icon" onClick={() => { this.mobileMenuToggle(); }}>
            <Icon size="large" name="bars" />
          </div>
        </Menu>
        {/* <ContactUs
          show={this.state.contact}
          handleClose={this.handleModalClose}
          closeModal={this.closeModal}
        /> */}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/navbar.js